import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { removeEmojis } from '@app/core/utils';

@Component({
  selector: 'rk-notification-form-message-input',
  standalone: false,
  templateUrl: './notification-form-message-input.component.html',
  styleUrl: './notification-form-message-input.component.scss',
})
export class NotificationFormMessageInputComponent {
  @Input({ required: true }) messageControl!: FormControl<string>;

  removeEmojis(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    const noEmoji = removeEmojis(textarea.value);
    this.messageControl.setValue(noEmoji);
  }
}
